import { axiosInstance } from '../../axios';
import {
  ContentfulTag,
  CreateContentfulTagPayload,
  UpdateContentfulTagPayload,
} from './contentful-tag.interface';

export function fetchContentfulTags() {
  return axiosInstance
    .get<ContentfulTag[]>('/api/admin/contentful-tag')
    .then((response) => response.data);
}

export function createContentfulTag(payload: CreateContentfulTagPayload) {
  return axiosInstance
    .post<ContentfulTag>('/api/admin/contentful-tag', payload)
    .then((response) => response.data);
}

export function updateContentfulTag(
  id: string,
  payload: UpdateContentfulTagPayload,
) {
  return axiosInstance
    .patch<ContentfulTag>(`/api/admin/contentful-tag/${id}`, payload)
    .then((response) => response.data);
}

export function deleteContentfulTag(id: string) {
  return axiosInstance
    .delete<ContentfulTag>(`/api/admin/contentful-tag/${id}`)
    .then((response) => response.data);
}
